import { useEffect, useContext, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Utils from "../../Utils";
import axios from "axios";

const PhPhotoshootDetails = (props) => {
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const fileInputRefPh = useRef(null);
  
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
  };

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            setStatus(res.data.statuses);
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);

  /* Classes for specific status */
  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    "Pending": "status-pill inline-block bg-pink-50 text-pink-700",
    "Completed": "status-pill inline-block bg-gray-200 text-gray-700",
  };

  /* Hotel types */
  const hotel_types = {
    "new": "New Property",
    "converted": "Converted Property",
    "established": "Established Property",
  };

  /* Labels for status */
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0 || code === 1) return 'Pending';
    if (code >= 2 && code <= 6) return 'In-Process';
    if (code === 7 || code === 8) return 'Completed';

    return 'Unknown';
  };

  /* Recce Images Listing */
  const [recceImages, setRecceImages] = useState([]);
  const updateRecceImages = () => {
        axios
            .get(Utils.apiUrl(`photoshoot/recces/${id}?limit=9999`), Utils.apiHeaders())
            .then((res) => {
                console.log(res.data);
                if(res.data.success) {
                    setRecceImages(res.data.data);
                }
            })
            .catch((err) => {
            //callback(false, err.message);
            });
  }
  
  const [photoshootDetails, setPhotoshootDetails] = useState([]);
  //const [hotelDetails, setHotelDetails] = useState([]);
  useEffect(() => {
    /* Getting Photoshoot Details */
    axios
        .get(Utils.apiUrl(`photoshoot/${id}`), Utils.apiHeaders())
        .then((res) => {
            if(res.status == 200) {
                setPhotoshootDetails(res.data);
                updateRecceImages();
                updatePhotoshootImages();
            }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);



  const downloadAttachment = (id) => {
    axios
        .get(Utils.apiUrl(`photoshoot/attachment/${id}`), {
            responseType: 'arraybuffer', // Important for binary data
            ...Utils.apiHeaders()
        })
        .then((res) => {
            console.log(res.data);

            // Convert buffer data into file
            const bufferData = res.data;

            // Convert to Uint8Array
            const byteArray = new Uint8Array(bufferData);

            // Create a Blob (set correct MIME type from response headers)
            const blob = new Blob([byteArray], { type: res.headers['content-type'] || 'application/octet-stream' });

            // Get filename from headers or default
            const contentDisposition = res.headers['content-disposition'];
            const filename = contentDisposition 
                ? contentDisposition.split('filename=')[1]?.replace(/"/g, '') || `attachment_${id}`
                : `attachment_${id}`;

            // Create download link
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();

            // Cleanup
            URL.revokeObjectURL(url);
            document.body.removeChild(a);
        })
        .catch((err) => {
            console.error('Download failed:', err);
            alert('Failed to download attachment');
        });
  }


  const [activeTab, setActiveTab] = useState("details");
  const [activePsTab, setActivePsTab] = useState("uploaded");

  // Drag and drop handlers for Recce Images
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      fileInputRef.current.files = files;
      // Trigger change event to upload
      fileInputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('recces', files[i]);
      }
      axios
        .post(Utils.apiUrl(`photoshoot/recces/${id}`), formData, Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            updateRecceImages();
            alert(res.data.message);
          }
          else {
            alert(res.data.message);
          }
          // Optionally, show success message or update UI
        })
        .catch((err) => {
          console.error('Upload failed:', err);
          // Optionally, show error message
        });
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };
  //updateRecceImages();

  const deleteUplodedFile = (id) => {
    //if(confirm("Are you sure you want to delete this file?")) {
        axios
            .delete(Utils.apiUrl(`photoshoot/recce/${id}`), Utils.apiHeaders())
            .then((res) => {
                console.log(res.data);
                if(res.data.success) {
                    alert(res.data.message);
                    updateRecceImages();
                }
                else {
                    alert(res.data.message);
                }
            })
            .catch((err) => {
            //callback(false, err.message);
            });
    //}
  }



  /* Photoshoot Images Listing */
  const [photoshootImages, setPhotoshootImages] = useState([]);
  const updatePhotoshootImages = () => {
        axios
            .get(Utils.apiUrl(`photoshoot/photos?psid=${id}`), Utils.apiHeaders())
            .then((res) => {
                console.log(res.data);
                if(res.data.success) {
                    setPhotoshootImages(res.data.data);
                }
            })
            .catch((err) => {
            //callback(false, err.message);
            });
  }

  /* For deleting uploaded photoshoot file */
  const deletePhotoshootFile = (id) => {
    //if(confirm("Are you sure you want to delete this file?")) {
        axios
            .delete(Utils.apiUrl(`photoshoot/photo/${id}`), Utils.apiHeaders())
            .then((res) => {
                console.log(res.data);
                if(res.data.success) {
                    alert(res.data.message);
                    updatePhotoshootImages();
                }
                else {
                    alert(res.data.message);
                }
            })
            .catch((err) => {
            //callback(false, err.message);
            });
    //}
  }

  // Drag and drop handlers for Photoshoot Images
  const handleDragOverPh = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeavePh = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDropPh = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      fileInputRef.current.files = files;
      // Trigger change event to upload
      fileInputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const handleFileChangePh = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const formDataPh = new FormData();
      for (let i = 0; i < files.length; i++) {
        formDataPh.append('photos', files[i]);
      }
      axios
        .post(Utils.apiUrl(`photoshoot/photos?psid=${id}`), formDataPh, Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            updatePhotoshootImages();
            alert(res.data.message);
          }
          else {
            alert(res.data.message);
          }
          // Optionally, show success message or update UI
        })
        .catch((err) => {
          console.error('Upload failed:', err);
          // Optionally, show error message
        });
    }
  };

  const handleClickPh = () => {
    fileInputRefPh.current.click();
  };

  return (
    <>
    <div class="container mx-auto p-8">
        <h1 class="text-3xl font-bold text-gray-800 mb-8">Photoshoot Details</h1>
        <div class="bg-white rounded-lg shadow p-6">
            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <div>
                        <h2 class="text-2xl font-semibold">{photoshootDetails.title}</h2>
                        <p class="text-sm text-gray-500 mt-1">Marsha Code: <span class="font-medium text-gray-800">{photoshootDetails.marsha}</span></p>
                        <p className="text-sm text-gray-500">Status: <span className="font-medium text-gray-700">{photoshootDetails.status_label}</span></p>
                    </div>
                </div>
                <div class="text-right">
                    <div className={statusClasses[getStatusLabel(photoshootDetails.status)]}><i class="fa-solid fa-circle"></i></div>
                </div>
            </div>

            {/* <!-- Tabs --> */}
            <div class="mt-6">
                <div class="flex space-x-2 border-b pb-3">
                    <button className={`tab-btn ${activeTab === "details" ? "active" : "bg-gray-100"}`} data-tab="details" onClick={() => setActiveTab('details')}>Photoshoot Details</button>
                    <button className={`tab-btn ${activeTab === "recce" ? "active" : "bg-gray-100"}`} data-tab="recce" onClick={() => setActiveTab('recce')}>Recce</button>
                    <button className={`tab-btn ${activeTab === "photoshoot" ? "active" : "bg-gray-100"}`} data-tab="photoshoot" onClick={() => setActiveTab('photoshoot')}>Post Production Image Review</button>
                    <button className="tabbtn bg-gray-100 text-gray-300" data-tab="" onClick={() => setActiveTab('approvedimages')}>Approved Images</button>
                    <button className="tabbtn bg-gray-100 text-gray-300" data-tab="" onClick={() => setActiveTab('usagerights')}>Usage Rights</button>
                </div>

                <div class="mt-6">
                    {/* <!-- Tab: Photoshoot Details --> */}
                    <div id="tab-details" className={`tab-panel ${activeTab === "details" ? "active" : "hidden"}`}>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                            <div>
                                <p class="text-sm text-gray-600">Marsha Code</p>
                                <p class="font-semibold text-gray-800">{photoshootDetails.marsha}</p>

                                <p class="text-sm text-gray-600 mt-4">Country</p>
                                <p class="font-semibold text-gray-800">{photoshootDetails.cname}</p>

                                <p class="text-sm text-gray-600 mt-4">Type</p>
                                <p class="font-semibold text-gray-800">{hotel_types[photoshootDetails.hotel_type]}</p>

                                <p class="text-sm text-gray-600 mt-4">Shoot Date</p>
                                <p class="font-semibold text-gray-800">{formatDate(photoshootDetails.date_from)} - {formatDate(photoshootDetails.date_to)}</p>
                            </div>

                            <div>
                                <p class="text-sm text-gray-600">Recce Completed By</p>
                                <p class="font-semibold text-gray-800">{(photoshootDetails.recce_end != null) ? formatDate(photoshootDetails.recce_end) : ''}</p>

                                <p class="text-sm text-gray-600 mt-4">Completion Date</p>
                                <p class="font-semibold text-gray-800">{(photoshootDetails.delivery_date != null) ? formatDate(photoshootDetails.delivery_date) : ''}</p>

                                <p class="text-sm text-gray-600 mt-4">Photographer</p>
                                <p class="font-semibold text-gray-800">{photoshootDetails.pgname}</p>

                                <p class="text-sm text-gray-600 mt-4">Hotel Representative</p>
                                <p class="font-semibold text-gray-800">{photoshootDetails.hrname}</p>
                            </div>
                        </div>

                        <div class="form-section">
                            <div class="section-heading">
                                <i class="fas fa-paperclip"></i>
                                Attachments
                            </div>

                            <div class="form-group">
                                {/* Loop for attachments */}
                                {photoshootDetails.attachments != undefined && photoshootDetails.attachments.length > 0 && (
                                    (photoshootDetails.attachments.map((attachment, index) =>
                                        <>
                                        <div class="attachment-item" onClick={() => downloadAttachment(attachment.id)}>
                                            <i class="fas fa-file-alt"></i>
                                            <span>Document {(index+1)}</span>
                                        </div>
                                        </>
                                    ))
                                    
                                )}
                                {/* If no attachments uploaded */}
                                {photoshootDetails.attachments != undefined && photoshootDetails.attachments.length == 0 && (
                                    <>
                                    <div class="attachment-item">
                                        No attachments uploaded
                                    </div>
                                    </>
                                )}
                            </div>
                        </div>

                    </div>

                    {/* <!-- Tab: Photoshoot --> */}
                    <div id="tab-recce" className={`tab-panel ${activeTab === "recce" ? "active" : "hidden"}`}>
                        <div id="drop-zone" class="drop-zone" onClick={handleClick} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>
                            Drag &amp; Drop files here or click to select
                            <input name="recces" type="file" id="file-input" multiple="multiple" className="hidden" ref={fileInputRef} onChange={handleFileChange} />
                        </div>
                        <div class="mt-8">
                            <div id="file-grid" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
                                {/* <!-- Tiles will be appended here --> */}
                                {recceImages.length > 0 && (
                                    recceImages
                                    //.filter(item => item.status === "submitted")
                                    .map((item, index) => (
                                    <>
                                    <div class="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                        <div class="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                            <img src={`${process.env.REACT_APP_API_URL}/photoshoot/recce/thumb/${item.fname}`} alt="" class="object-cover w-full h-full" />
                                        </div>
                                        <div class="p-3">
                                            <div class="text-sm font-semibold text-gray-800 truncate" title="">Image {(index+1)}</div>
                                        </div>
                                        <div class="absolute top-2 right-2 flex space-x-2">
                                            <button class="w-8 h-8 flex items-center justify-center rounded-full text-red-700" aria-label="Mark approved" onClick={() => deleteUplodedFile(item.id)}>
                                                <i class="fa-solid fa-x"></i>
                                            </button>
                                        </div>
                                    </div>
                                    </>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>

                    <div id="tab-photoshoot" className={`tab-panel ${activeTab === "photoshoot" ? "active" : "hidden"}`}>
                        <div id="drop-zone" class="drop-zone" onClick={handleClickPh} onDragOver={handleDragOverPh} onDragLeave={handleDragLeavePh} onDrop={handleDropPh}>
                            Drag &amp; Drop files here or click to select
                            <input name="photos" type="file" id="file-input" multiple="multiple" className="hidden" ref={fileInputRefPh} onChange={handleFileChangePh} />
                        </div>
                        <div class="mt-8">

                          {/* Sub Tabs */}
                          <div class="mb-4">
                              <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                                  <div>
                                      <div class="flex space-x-2" role="tablist" aria-label="Files Tabs">
                                          <button 
                                            class={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "uploaded" ? "active" : "bg-gray-100"}`} 
                                            data-tab="uploaded" 
                                            onClick={() => setActivePsTab('uploaded')}>Uploaded <span class="ml-2 text-sm text-gray-600">({photoshootImages
                                    .filter(item => item.status === "submitted").length})</span>
                                          </button>
                                          <button 
                                            class={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "edits" ? "active" : "bg-gray-100"}`} 
                                            data-tab="edits" 
                                            onClick={() => setActivePsTab('edits')}>Edits Needed <span class="ml-2 text-sm text-gray-600">({photoshootImages
                                    .filter(item => item.status === "ai-processed").length})</span>
                                          </button>
                                          <button 
                                            class={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "approved" ? "active" : "bg-gray-100"}`} 
                                            data-tab="approved" 
                                            onClick={() => setActivePsTab('approved')}>Approved <span class="ml-2 text-sm text-gray-600">({photoshootImages
                                    .filter(item => item.status === "bt-approved").length})</span>
                                          </button>
                                      </div>
                                  </div>
                                  <div class="text-right text-sm">
                                      <div class="block">Initially Uploaded: <span>{photoshootImages.length}</span></div>
                                      <div class="block">Revision Needed: <span>{photoshootImages
                                    .filter(item => item.status === "ai-processed").length}</span></div>
                                  </div>
                              </div>
                          </div>

                          {/* Uploaded Tab */}
                          {activePsTab === "uploaded" && (
                            <>
                            <h2 class="text-2xl font-semibold text-gray-700 mb-4">Uploaded</h2>
                            <div id="file-grid" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
                                {/* <!-- Tiles will be appended here --> */}
                                {photoshootImages.length > 0 && (
                                    photoshootImages
                                    .filter(item => item.status === "submitted")
                                    .map((item, index) => (
                                    <>
                                    <div class="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                        <div class="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                            <img src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`} alt="" class="object-cover w-full h-full" />
                                        </div>
                                        <div class="p-3">
                                            <div class="text-sm font-semibold text-gray-800 truncate" title="">Pic {(index+1)}</div>
                                        </div>
                                        <div class="absolute top-2 right-2 flex space-x-2">
                                            <button class="w-8 h-8 flex items-center justify-center rounded-full text-red-700" aria-label="Mark approved" onClick={() => deletePhotoshootFile(item.id)}>
                                                <i class="fa-solid fa-x"></i>
                                            </button>
                                        </div>
                                    </div>
                                    </>
                                    ))
                                )}
                            </div>
                            </>
                          )}

                          {/* Edits Needed Tab */}
                          {activePsTab === "edits" && (
                            <>
                            <h2 class="text-2xl font-semibold text-gray-700 mb-4">Edits Needed</h2>
                            {/* <div id="file-grid" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4"> */}
                                {/* <!-- Tiles will be appended here --> */}
                                {photoshootImages.length > 0 && (
                                    photoshootImages
                                    .filter(item => item.status === "ai-processed")
                                    .map((item, index) => (
                                    <>
                                    <ul class="space-y-4">
                                        <li class="flex items-center bg-white rounded-lg shadow-sm border p-3">
                                            <img src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`} alt="Pic 1" class="w-20 h-14 object-cover rounded mr-4" />
                                            <div class="flex-1">
                                                <div class="font-semibold text-gray-800">Pic {(index+1)}</div>
                                                {/* If BT Feedback is not blank */}
                                                {(item.bt_feedback != null && item.bt_feedback != '') && (
                                                    <div class="text-sm text-gray-600">{item.bt_feedback}</div>
                                                )}
                                                {/* If BT Feedback is blank showing AI Feedback */}
                                                {((item.bt_feedback == null || item.bt_feedback == '') && item.ai_feedback != undefined) && (
                                                    <>
                                                    <div class="text-sm text-gray-600">
                                                    {item.ai_feedback != '' && (() => {
                                                        try {
                                                            const parsed = JSON.parse(item.ai_feedback);
                                                            return parsed.feedback.map((feedback, index) => (
                                                                <p key={index}>{feedback}</p>
                                                            ));
                                                        } catch (e) {
                                                            return <p>Invalid AI feedback</p>;
                                                        }
                                                    })()}
                                                    </div>
                                                    </>
                                                )}
                                            </div>
                                            <div>
                                                <a href={`${process.env.REACT_APP_BASENAME}photographer-view-feedback/${id}/${item.id}`} class="inline-block items-center px-4 py-2 rounded btn">
                                                    <i class="fa-regular fa-eye"></i> View Details
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                    </>
                                    ))
                                )}
                            {/* </div> */}
                            </>
                          )}

                          {/* Approved Tab */}
                          {activePsTab === "approved" && (
                            <>
                            <h2 class="text-2xl font-semibold text-gray-700 mb-4">Approved</h2>
                            <div id="file-grid" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
                                {/* <!-- Tiles will be appended here --> */}
                                {photoshootImages.length > 0 && (
                                    photoshootImages
                                    .filter(item => item.status === "bt-approved")
                                    .map((item, index) => (
                                    <>
                                    <div class="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                        <div class="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                            <img src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`} alt="" class="object-cover w-full h-full" />
                                        </div>
                                        <div class="p-3">
                                            <div class="text-sm font-semibold text-gray-800 truncate" title="">Pic {(index+1)}</div>
                                        </div>
                                        {/* <div class="absolute top-2 right-2 flex space-x-2">
                                            <button class="w-8 h-8 flex items-center justify-center rounded-full text-red-700" aria-label="Mark approved" onClick={() => deletePhotoshootFile(item.id)}>
                                                <i class="fa-solid fa-x"></i>
                                            </button>
                                        </div> */}
                                    </div>
                                    </>
                                    ))
                                )}
                            </div>
                            </>
                          )}
                          


                        </div>
                    </div>

                    {/* <div id="tab-Photoshootstatus" class="tab-panel hidden">
                        <div class="text-center p-8 bg-gray-100 border-radius-xl">
                            <h3>Recce in progress</h3>
                        </div>
                    </div> */}

                    {/* <!-- Tab: Contact Sheet (placeholder) --> */}
                    <div id="tab-approvedimages" className={`tab-panel ${activeTab === "approvedimages" ? "active" : "hidden"}`}>
                        <p class="text-gray-600">Approved Images not available yet.</p>
                    </div>

                    {/* <!-- Tab: Usage Rights (placeholder) --> */}
                    <div id="tab-usagerights" className={`tab-panel ${activeTab === "usagerights" ? "active" : "hidden"}`}>
                        <p class="text-gray-600">Usage rights are not available yet.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  );
};

export default PhPhotoshootDetails;
